import axios from '../base.js'
export default class ZYTS {
  // 总量统计
  static async reqGetzltjData() {
    let res = await axios.get('./data/ZYTS/zltjData.json');
    return res.data;
  }
  // 分中心计算资源
  static async reqGetfzxjszyData() {
    let res = await axios.get('./data/ZYTS/fzxjszyData.json');
    return res.data;
  }
  // 资源设备类型统计
  static async reqGetzysblttjData() {
    let res = await axios.get('./data/ZYTS/zysblttjData.json');
    return res.data;
  }
  // 资源使用率月变化趋势
  static async reqGetzysylybhqsData() {
    let res = await axios.get('./data/ZYTS/zysylybhqsData.json');
    return res.data;
  }
  // 机房分布图
  static async reqGetjffbtData() {
    let res = await axios.get('./data/ZYTS/jffbtData.json');
    return res.data;
  }
  // 机房报表
  static async reqGetjfbbData(p) {
    let res = await axios.get(`./data/ZYTS/jfbbData${p}.json`);
    return res.data;
  }
  // 分中心业务告警
  static async reqGetfzxywgjData() {
    let res = await axios.get('./data/ZYTS/fzxywgjData.json');
    return res.data;
  }
}